import React, { useMemo, useState } from 'react';
import { Divider, HStack, IconInfo, LoadingSpinner, Stack, Text, } from '@adc/parallax-component-library';
import { useApiError, useLibrePartner, useToast } from 'Hooks';
import { InfoModal, Link, RichText } from 'Components/utility';
import { formatDate } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const PartnerApi = ({ partnerConnection }) => {
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [footerLoading, setFooterLoading] = useState(false);
    const { showApiErrorModal } = useApiError();
    const { showToast } = useToast();
    const { removePartner, showStopSharingModal } = useLibrePartner();
    const scopes = useMemo(() => [
        ...new Set(partnerConnection.consent.scopes.reduce((acc, scope) => {
            const splittedScope = scope.split('.');
            if (splittedScope.length > 1) {
                acc.push(splittedScope[1]);
            }
            return acc;
        }, [])),
    ], [partnerConnection.consent.scopes]);
    const scopesStr = useMemo(() => {
        const scopeStrArr = scopes.map((key) => i18n.t(`Global.microcopy.scopes.${key}`).toLowerCase());
        scopeStrArr[0] = scopeStrArr[0].split('')[0].toUpperCase() + scopeStrArr[0].slice(1);
        return scopeStrArr.join(', ');
    }, [scopes]);
    const scopesModal = useMemo(() => {
        return (React.createElement(Stack, { gap: "$4" }, scopes.map((scope) => {
            return (React.createElement(Stack, { key: scope },
                React.createElement(Text, { testID: `ConnectedOAuthPartner.scope.${scope}`, marginBottom: "$2", color: "$text.100", fontWeight: "$bodyBase.strong", fontSize: "$bodyBase.strong" }, `${i18n.t(`Connections.modals.dataSharingBottomSheet.${scope}Title`)}`),
                React.createElement(Stack, { marginLeft: "$3" },
                    React.createElement(RichText, { fontToken: "$bodySmall.default", testID: `ConnectedOAuthPartner.scope.${scope}.description`, text: i18n.t(`Connections.modals.dataSharingBottomSheet.${scope}`) }))));
        })));
    }, [scopes]);
    const onStopSharing = () => {
        showStopSharingModal(partnerConnection.partner.name, 'ConnectedOAuthPartner.modals.stopSharingOAuthPartner.title', 'ConnectedOAuthPartner.modals.stopSharingOAuthPartner.body', async () => {
            try {
                setFooterLoading(true);
                await removePartner(partnerConnection.partner.id);
                showToast({
                    message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
                    'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved'),
                });
                mediator.publish('router:navigate', '/connections');
            }
            catch {
                showApiErrorModal();
            }
            finally {
                setFooterLoading(false);
            }
        });
    };
    return (React.createElement(Stack, { margin: "$4", padding: "$4", backgroundColor: "$surface.container", border: "$1.5", shadow: "$1" },
        React.createElement(Text, { testID: "ConnectedOAuthPartner.title", color: "$text.100", fontWeight: "$h4.strong", fontSize: "$h4.strong" }, i18n.t('ConnectedOAuthPartner.content.connectedOAuthPartnerTile.primaryText')),
        React.createElement(Text, { testID: "ConnectedOAuthPartner.bodyText", marginTop: "$2", color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default" }, i18n.t('ConnectedOAuthPartner.content.connectedOAuthPartnerTile.secondaryText', {
            partnerName: partnerConnection.partner.name,
        })),
        React.createElement(HStack, { justifyContent: "space-between", alignItems: "flex-start", marginTop: "$4" },
            React.createElement(Text, { testID: "ConnectedOAuthPartner.scopes", color: "$text.100", fontWeight: "$bodyBase.medium", fontSize: "$bodyBase.medium" }, scopesStr),
            React.createElement(Stack, { onPress: () => setShowModalInfo(true), cursor: "pointer" },
                React.createElement(IconInfo, { testID: "ConnectedOAuthPartner.info-icon", size: "S", color: "$interactive.core.enabled" }))),
        React.createElement(Text, { testID: "ConnectedOAuthPartner.connectedAt", marginTop: "$4", color: "$text.60", fontWeight: "$bodySmall.default", fontSize: "$bodySmall.default" }, `${i18n.t('ConnectedOAuthPartner.content.connectedOAuthPartnerTile.bodyText')} ${formatDate(partnerConnection.consent.created)}`),
        React.createElement(Divider, { marginVertical: "$4", borderColor: "$neutral.40" }),
        footerLoading ? (React.createElement(Stack, { width: "100%", display: "flex", alignItems: "center" },
            React.createElement(LoadingSpinner, null))) : (React.createElement(Link, { testID: "ConnectedOAuthPartner.stopSharing-btn", onPress: onStopSharing, textColor: "$support.danger.default" }, i18n.t('Global.modals.stopSharing.title'))),
        React.createElement(InfoModal, { isOpen: showModalInfo, title: i18n.t('Connections.modals.dataSharingBottomSheet.title'), customBody: scopesModal, handleClose: () => setShowModalInfo(false) })));
};
export default PartnerApi;
